import React from 'react';
import styled from 'styled-components';
import { spacer8 } from '@spotify-internal/encore-web';
import { LanguageSelectionTrigger } from '../../../../features/src/i18n/components/LanguageSelection/Trigger';
import { LanguageSelectionTooltip } from '../../../../features/src/i18n/components/LanguageSelection/Tooltip';
import { LanguageSelectionBoundary } from '../../../../features/src/i18n/components/LanguageSelection/Boundary';
import { useTracking } from '../../Tracking';

const MenuItem = styled.li`
  display: flex;
  align-self: center;
  margin-inline: ${spacer8};

  &:empty {
    display: none;
  }
`;

const CustomTrigger = styled(LanguageSelectionTrigger)`
  &,
  &:hover,
  &:focus,
  &:focus:after {
    color: currentColor;
    border-color: currentColor;
  }
`;

export const NavBarLanguageItem = () => {
  const { eventHandlerWithAction } = useTracking();
  return (
    <MenuItem
      onClick={eventHandlerWithAction(
        'Frodor - module - Language Picker',
        'click',
        'clicked-language-picker',
      )}
    >
      <LanguageSelectionBoundary fallback={null}>
        <LanguageSelectionTooltip>
          <CustomTrigger buttonSize="sm" desktop />
        </LanguageSelectionTooltip>
      </LanguageSelectionBoundary>
    </MenuItem>
  );
};

type SideMenuLanguageSectionProps = {
  onButtonClick: (e: React.MouseEvent) => void;
};

export const SideMenuLanguageSection = ({
  onButtonClick,
}: SideMenuLanguageSectionProps) => {
  const { eventHandlerWithAction } = useTracking();
  return (
    <div
      className="encore-creator-dark-theme"
      onClick={eventHandlerWithAction(
        'Frodor - module - Side Menu Language Picker',
        'click',
        'clicked-language-picker',
      )}
    >
      <LanguageSelectionBoundary fallback={null}>
        <LanguageSelectionTrigger onClick={onButtonClick} desktop={false} />
      </LanguageSelectionBoundary>
    </div>
  );
};

type SideMenuLanguageOnboardingProps = {
  placement?: 'top' | 'bottom';
  children: React.ReactNode;
};

export const SideMenuLanguageOnboarding = ({
  placement,
  children,
}: SideMenuLanguageOnboardingProps) => {
  return (
    <LanguageSelectionBoundary fallback={children}>
      <LanguageSelectionTooltip placement={placement}>
        {children}
      </LanguageSelectionTooltip>
    </LanguageSelectionBoundary>
  );
};
